module.exports = __webpack_public_path__ + "c8f71882eb31c5d73a54ccb7a6b6a6ea.svg";